import React, { PropTypes } from 'react'
import {Col, Row, Carousel, Tooltip, OverlayTrigger} from 'react-bootstrap'
import {Actions} from 'jumpstate'
import {isOnUploadSlide, switchToSlide, renderDescriptions, renderPhotos, giveColSizeWhen} from './Slider/SlideHelper'
import Uploader from './Uploader/Uploader'
import SliderThumbnail from './Slider/SliderThumbnail'
import {MdAddAPhoto, MdDelete, MdUndo} from '../Common/ReactIcons/icons'
import PhotoLightBox from '../HorseInfo/PhotoLightBox'
import {TransitionGroup, CSSTransition} from 'react-transition-group'
import ImageForm from '../HorseInfo/ImageForm/ImageForm'
import {Form} from 'react-form'

const cleanUploadForm = {
  title: '',
  title_fa: '',
  description: '',
  description_fa: ''
}

class HorsePhotos extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      currentSlide: 0,
      isShowingPhotos: false,
      hasPhotos: false,
      isFirstLoad: true,
      indexOfUploadSlide: props.photos.length,
      uploaderForm: cleanUploadForm,
      returnToUploadSlideTimer: undefined,
      showFullScreen: false
    }
    this.uploadNow = this.uploadNow.bind(this)
    this.chooseAvatar = this.chooseAvatar.bind(this)
    this.deletePhoto = this.deletePhoto.bind(this)
  }

  componentWillMount () {
    if (window.localStorage.newHorse) {
      Actions.loadNewHorse()
    }
    if (this.props.photos.length > 0) {
      this.setState({hasPhotos: true, indexOfUploadSlide: this.props.photos.length})
    }
    this.setState({currentSlide: this.state.indexOfUploadSlide, isShowingPhotos: false})
  }

  componentWillReceiveProps (nextProps) {
    if (this.state.isFirstLoad) { return undefined }
    if (nextProps.photos.length > 0) {
      this.setState({
        hasPhotos: true,
        indexOfUploadSlide: nextProps.photos.length,
        currentSlide: nextProps.photos.length - 1,
        isShowingPhotos: true
      })
    } else {
      this.setState({
        hasPhotos: false,
        currentSlide: nextProps.photos.length,
        isShowingPhotos: false})
    }
  }

  uploadNow (values) {
    if (!this.props.auth.isAuthenticated) { return Actions.toggleLoginBox(true) }
    this.setState({isFirstLoad: false}, () => {
      this.refs.uploader.startUpload(values, this.props.horse.id).then(() => {
        this.setState({
          uploaderForm: cleanUploadForm,
          hasPhotos: true,
          indexOfUploadSlide: this.props.photos.length,
          returnToUploadSlideTimer: setTimeout(() => switchToSlide(this.refs.slider, this.props.photos.length, this.state.indexOfUploadSlide), 3000)
        })
      })
    })
  }

  chooseAvatar () {
    Actions.selectNewHorseAvatar(this.props.photos[this.state.currentSlide])
  }

  deletePhoto () {
    const {photo_id} = this.props.photos[this.state.currentSlide]
    Actions.deleteNewHorsePhoto(photo_id)
  }

  render () {
    const {photos, horse} = this.props
    const {currentSlide, indexOfUploadSlide, isShowingPhotos, hasPhotos, uploaderForm, showFullScreen} = this.state

    const onSlideChange = (index) => {
      this.setState({currentSlide: index, isShowingPhotos: !isOnUploadSlide(index, indexOfUploadSlide)})
    }

    const showUpload = () => {
      if (isOnUploadSlide(currentSlide, indexOfUploadSlide)) { return undefined }
      if (this.state.returnToUploadSlideTimer) { clearTimeout(this.state.returnToUploadSlideTimer) }
      this.setState({isShowingPhotos: false, currentSlide: indexOfUploadSlide, returnToUploadSlideTimer: undefined})
      switchToSlide(this.refs.slider, this.props.photos.length, this.state.indexOfUploadSlide)
    }

    /** *
     * CAUTION: check for having at least one photo before call this method
     */
    const hideUpload = () => {
      this.setState({hasPhotos: true, isShowingPhotos: true, currentSlide: 0})
      switchToSlide(this.refs.slider, photos.length, 0)
    }

    const renderUploaderSlide = (<Carousel.Item key={indexOfUploadSlide}>
      <div id="AddNewPhotoSlide">
        <Uploader ref="uploader" newPhotoParams={uploaderForm} />
      </div>
    </Carousel.Item>)

    const tooltipRemove = (
      <Tooltip id="tooltip">حذف تصویر</Tooltip>
    )
    const tooltipAvatar = (
      <Tooltip id="tooltip">انتخاب به عنوان آواتار</Tooltip>
    )
    const tooltipNewPhoto = (
      <Tooltip id="tooltip">آپلود تصویر جدید</Tooltip>
    )
    const tooltipUndo = (
      <Tooltip id="tooltip">بازگشت</Tooltip>
    )

    return (
      <Row className="Box">
        <Col xs={12} id="HorsePhotoBox">
          <Row id="HorsePhotoTop">
            <Col xs={12}>
              <Carousel className={!hasPhotos && 'HideControl'} id="carousel-photos" ref="slider" defaultActiveIndex={indexOfUploadSlide} onSelect={onSlideChange} indicators controls interval={null}>
                {renderPhotos(photos, () => this.setState({showFullScreen: true}))} {renderUploaderSlide}
              </Carousel>
              {(hasPhotos && isShowingPhotos) && <OverlayTrigger placement="top" overlay={tooltipNewPhoto}><div id="AddNewPhoto" onClick={showUpload}><MdAddAPhoto /></div></OverlayTrigger>}
              {(hasPhotos && isShowingPhotos && !horse.id) && <OverlayTrigger placement="top" overlay={tooltipAvatar}><div id="AddAvatar" onClick={this.chooseAvatar}><div className="AddAvatarIcon" /></div></OverlayTrigger>}
              {(hasPhotos && isShowingPhotos && !horse.id) && <OverlayTrigger placement="top" overlay={tooltipRemove}><div id="removePhoto" onClick={this.deletePhoto}><MdDelete /></div></OverlayTrigger>}
              {(hasPhotos && !isShowingPhotos) && <OverlayTrigger placement="top" overlay={tooltipUndo}><div id="CloseNewPhoto" onClick={hideUpload}><MdUndo /></div></OverlayTrigger>}
            </Col>
          </Row>
          <Row id="HorsePhotoBottom">
            <Col xs={giveColSizeWhen(isShowingPhotos)} className="CaptionPhotos">
              {isShowingPhotos && renderDescriptions(photos, currentSlide)}
              <div className={isOnUploadSlide(currentSlide, indexOfUploadSlide) && 'CaptionPhotosBox CaptionPhotosActive'}>
                {!isShowingPhotos && <Form
                  values={uploaderForm}
                  onSubmit={this.uploadNow}>
                  {ImageForm}
                  </Form>}
              </div>
            </Col>
            {isShowingPhotos &&
              <Col xs={4}>
                <SliderThumbnail photos={photos} slider={this.refs.slider} />
              </Col>}
            {this.refs.slider && <TransitionGroup enter appear exit>
              {showFullScreen && <CSSTransition classNames="sl-fade" timeout={1000} in={showFullScreen} mountOnEnter unmountOnExit>
                <PhotoLightBox
                  hider={() => this.setState({showFullScreen: false})}
                  photos={photos}
                  currentPhoto={this.refs.slider.getActiveIndex()}
                />
              </CSSTransition>}
            </TransitionGroup>}
          </Row>
        </Col>
      </Row>
    )
  }
}

HorsePhotos.propTypes = {
  horse: PropTypes.object,
  photos: PropTypes.array,
  auth: PropTypes.object
}

export default HorsePhotos



// WEBPACK FOOTER //
// ./src/components/NewHorse/HorsePhotos.js